<template>
  <div class="case-detail-region-publication-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ $t('DIALOG.caseDetailRegionPublication.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="data-container col-block" :style="{ flex: 1 }">
      <div class="data-title-container row-block">
        <div
          class="data-title"
          v-html="[
            regionData.region_classification,
            regionData.SV_type,
            [
              'chr' + regionData.SV_chrom,
              regionData.CytoBand
            ].map(v => '(' + v + ')').join('')
          ].join(' ')"
        ></div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="data-tab-list-container row-block">
        <div class="data-tab-list-block row-block">
          <div class="data-tab-field col-block width-full" :class="{ active: option.value === tab }" v-for="(option, oindex) in tabOptions" :key="oindex" @click="e => tab = option.value">
            <div class="data-tab-container center-block">
              <div class="data-tab-block row-block">
                <div class="data-tab-title">{{ option.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '20px' }"></div>
      <div class="data-content-container col-block width-full" :style="{ flex: 1 }">
        <regionPublicationData
          v-show="option.value === tab"
          v-for="(option, oindex) in tabOptions"
          :key="oindex"
          :type="option.value"
          v-bind="param"
          @loaded="total => setTotalData(option.value, total)"
        ></regionPublicationData>
      </div>
    </div>
    <div :style="{ height: '0' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import regionPublicationData from '../caseDetail/regionPublicationData.vue'

export default {
  components: {
    regionPublicationData
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      tab: this.param.tab,
      dataKey: null,
      totalDatas: null
    }
  },
  computed: {
    // static
    tabOptions () {
      return [
        {
          title: this.$t('DIALOG.caseDetailRegionPublication.tab.title.___gnomAD_SV'),
          value: 'gnomAD'
        },
        {
          title: this.$t('DIALOG.caseDetailRegionPublication.tab.title.___dbVar'),
          value: 'dbVar'
        }
      ]
    },
    // param
    regionData () {
      return this.param.regionData
    }
  },
  methods: {
    setTotalData (key, value) {
      if (!this.totalDatas) {
        this.totalDatas = this.tabOptions.reduce((data, option) => ({ ...data, [option.value]: null }), {})
      }
      this.totalDatas[key] = value
      if (value) {
        this.dataKey = key
      }
      if (Object.values(this.totalDatas).every(value => value !== null)) {
        this.tab = this.tab || this.dataKey || 'gnomAD'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailRegionPublication.vue